export const INITIAL_CONVERSATION_RATINGS_STATE = { allConversationRatings: [] };
export const INITIAL_RATING_SCORE_DATA = {
  ratingScoreDetails: {},
  selectedExpert: {},
  currentlyActiveNode: 0,
};
